import { forwardRef, FunctionComponent } from "react"
import { iEmployee, iEmployeePicklistItem } from "../../../cached-data/types"
import { ResourceObject } from "../../../dashboard-data/types"

type tProps = {
    value: {
        employee: ResourceObject<iEmployee>
        picklistKey: "licenses" | "certifications" | "unions"
    }
}

const EmployeePicklistArrayCellEditor: FunctionComponent<tProps> = forwardRef((props: tProps) => {
    // This makes the cell editor look like the cell renderer for this so that
    // When the cell editor opens it doesn't look janky

    const picklistItems = props.value.employee[props.value.picklistKey] || []
    const picklistItemNames = picklistItems
        .map((item: iEmployeePicklistItem) => item.name)
        .sort()
        .join(", ")

    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            }}
        >
            {picklistItemNames}
        </div>
    )
})

export default EmployeePicklistArrayCellEditor
